import {Component, ElementRef, Input, OnChanges, OnInit, SimpleChanges, ViewChild} from '@angular/core';
import {WorkOrderService} from '../../../../Services/work-order.service';
import {BsToastService} from '../../../../Services/bs-toast-service';
import {ConfirmDialogService} from '../../../../Services/confirm-dialog.service';
import {DataService} from '../../../../Services/data.service';

@Component({
  selector: 'app-wo-attachments-tab',
  templateUrl: './wo-attachments-tab.component.html',
  standalone: false,
})
export class WoAttachmentsTabComponent implements OnInit, OnChanges {
  @Input() headerId: string | null = null;
  @Input() readonly = false;

  @ViewChild('fileInput') fileInput: ElementRef<HTMLInputElement>;

  attachments: any[] = [];
  isLoaded = false;
  previewUrl: string | null = null;
  uploading = false;

  constructor(
    private woService: WorkOrderService,
    private notification: BsToastService,
    public confirmDialog: ConfirmDialogService,
    private dataService: DataService,
  ) {
  }

  ngOnInit(): void {
    this.load();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['headerId'] && !changes['headerId'].firstChange) {
      this.load();
    }
  }

  load(): void {
    if (!this.headerId) {
      this.isLoaded = true;
      return;
    }
    this.woService.getWorkOrder(this.headerId).subscribe({
      next: (res: any) => {
        this.attachments = res?.wo_attachments ?? [];
        this.isLoaded = true;
      },
      error: () => {
        this.isLoaded = true;
      }
    });
  }

  isImage(att: any): boolean {
    const name: string = att.file_name ?? att.name ?? att.attachment ?? '';
    return /\.(jpg|jpeg|png|gif|webp|bmp|svg)$/i.test(name);
  }

  openPreview(url: string): void {
    this.previewUrl = url;
  }

  closePreview(): void {
    this.previewUrl = null;
  }

  uploadFile(event: Event): void {
    const input = event.target as HTMLInputElement;
    const file = input?.files?.[0];
    if (!file || !this.headerId) {
      return;
    }
    const maxSize = 10 * 1024 * 1024; // 10 MB
    if (file.size > maxSize) {
      this.notification.showErrorToast('File exceeds the 10 MB limit. Please choose a smaller file.');
      if (this.fileInput) {
        this.fileInput.nativeElement.value = '';
      }
      return;
    }
    this.uploading = true;
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => {
      const ext = file.name.split('.').pop() ?? '';
      const postRec = {
        header_id: this.headerId,
        file_name: file.name,
        type: ext,
        attachment: reader.result as string,
        audit_sequence: 0
      };
      this.dataService.post('wo_attachments', postRec).subscribe({
        next: () => {
          this.uploading = false;
          if (this.fileInput) {
            this.fileInput.nativeElement.value = '';
          }
          this.load();
        },
        error: () => {
          this.uploading = false;
          this.notification.showErrorToast('Error uploading attachment.');
        }
      });
    };
    reader.onerror = () => {
      this.uploading = false;
      this.notification.showErrorToast('Error reading file.');
    };
  }

  remove(index: number): void {
    this.confirmDialog.confirmThis(
      ['Delete this attachment?'],
      () => {
        const att = this.attachments[index];
        if (att.id && this.headerId) {
          this.woService.deleteAttachment(this.headerId, att.id).subscribe({
            next: () => {
              this.attachments.splice(index, 1);
            },
            error: () => {
              this.notification.showErrorToast('Error deleting attachment.');
            }
          });
        } else {
          this.attachments.splice(index, 1);
        }
      },
      () => {
      }
    );
  }
}
